<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13icglt/tc-custom/9781647000219.jpg?1708752099086" alt="This image is the cover for the book Seasonal Slow Knitting"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Seasonal Slow Knitting
      </h1>
      <p class="bookDescription body article font2">
        <b>“Thiessen’s new book is all about promoting creativity at a slower pace, offering advice on finding the time and space to knit in a restful, calming way.” —<i>The Knitter</i></b><br/><br/>  <i>Slow Knitting </i>introduced crafters to a process of more mindful making through five basic tenets: source carefully, make thoughtfully, think seasonally, experiment fearlessly, and explore openly. Now, this seasonal approach encourages knitters to delve deeper into those concepts, applying them to everyday making through a series of essays, projects, and patterns that explore the life of a knitter throughout the year. Organized similarly to a seasonal planting guide or farmer’s almanac, each chapter and section is designed to identify and encourage small ways that knitters may begin to employ noticeable change: organizing your yarn stash, carving out time for knitting, and starting on that baby blanket in a timely manner. The ideas explored here add up to a fuller, more mindful year, all through the joyful experience that is knitting. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hannah Thiessen, Katie Starks
      </h2>
      
      <p class="authorDescription body article">Hannah Thiessen is an experienced knitter, knitwear designer, teacher, and author of Slow Knitting. She lives in Nashville.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Abrams
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?003f0b5e